<template>
  <div class="jumbotron jumbotron-fluid">
    <div class="container">
      <h1 class="display-4">Sınav Sonuçları</h1>
      <div class="card">
        <div class="card-body" v-if="ready">
          <div class="list-group list-group-flush my-n3">
            
            <div class="list-group-item">
              <div class="row align-items-center">
                <div class="col">
                  <h5 class="mb-0">
                    <span class="text-success">●</span> DOĞRU CEVAP
                  </h5>
                </div>
                <div class="col-auto">
                  <p class="text-success small">{{ score.true }}</p>
                </div>
              </div>
            </div>

            <div class="list-group-item">
              <div class="row align-items-center">
                <div class="col">
                  <h5 class="mb-0">
                    <span class="text-danger">●</span> YANLIŞ CEVAP
                  </h5>
                </div>
                <div class="col-auto">
                  <p class="text-danger small">{{ score.false }}</p>
                </div>
              </div>
            </div>

            <div class="list-group-item">
              <div class="row align-items-center">
                <div class="col">
                  <h5 class="mb-0">
                    <span class="text-warning">●</span> BOŞ CEVAP
                  </h5>
                </div>
                <div class="col-auto">
                  <p class="text-warning small">{{ score.empty }}</p>
                </div>
              </div>
            </div>

            <div class="list-group-item" v-if="score.cancel">
              <div class="row align-items-center">
                <div class="col">
                  <h5 class="mb-0">
                    <span class="text-dark">●</span> İPTAL OLAN SORU
                  </h5>
                </div>
                <div class="col-auto">
                  <p class="text-dark small">{{ score.cancel }}</p>
                </div>
              </div>
            </div>

            <div class="list-group-item">
              <div class="row align-items-center">
                <div class="col">
                  <h5 class="mb-0">
                    <span class="text-primary">●</span> SINAV PUANI
                  </h5>
                </div>
                <div class="col-auto">
                  <p class="text-primary small">{{ totalScore }}</p>
                </div>
              </div>
            </div>

          </div>

          <div class="row align-items-center">
            <div class="col">
              <div class="row align-items-center no-gutters">
                <div class="col-auto">
                  <div class="small mr-2">BAŞARI YÜZDEN: {{ score.score }}%</div>
                </div>
                <div class="col">
                  <div class="progress progress-sm">
                    <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :style="'width: ' + score.score + '%'" :aria-valuenow="score.score" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ScoreBoard',
  props: ['score'],
  data() {
    return {
      ready: false
    }
  },
  computed: {
    totalScore: function() {

      let questionCount = this.score.true + this.score.false + this.score.empty
      
      let negativeBalance = this.score.false / 3;
      let netTrueAnswer = this.score.true - negativeBalance;

      let percentage = ( 100 / questionCount ) * netTrueAnswer

      return parseFloat(percentage).toFixed(2);
    }
  },
  created() {
    this.ready = true
  }
}
</script>